/*eslint-disable*/
import React from "react";

// @mui/material components
import { makeStyles } from "@mui/styles";
import MuiDialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

const useStyles = makeStyles((theme) => ({
    root: {
      margin: 0,
      padding: '16px',
      marginLeft: "1rem",
    },
    dialogTitle: {
      marginTop: "0.7rem",
      fontSize: "1.3rem",
      fontWeight: "500",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
    closeButton: {
      position: "absolute",
      right: '8px',
      top: '8px',
      color: '#9e9e9e',
    },
    button: {
      backgroundColor: "",
      bordertopleftradius: 0,
      borderbottomleftradius: 0,
      bordertoprightradius: "5px",
      borderbottomrightradius: "5px",
      height: "34px",
      width: "32px",
      textalign: "center",
      display: "flex",
      alignitems: "center",
      justifycontent: "center",
      "&:hover": {
        cursor: "pointer",
      },
    },
  }));

function CustomDialogTitle(props) {
  const { children, onClose, ...other } = props;
  const classes = useStyles();

  return (
    <MuiDialogTitle disableTypography={true} className={classes.root} {...other}>
      <Typography className={classes.dialogTitle} variant="h3">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
}

export default CustomDialogTitle;